import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.player = this.el.querySelector('.videoPlayer')

    this.initEventlisteners()
  }

  initEventlisteners() {
    window.addEventListener('scroll', () => {
      if (window.innerWidth < 900) this.animateVideo()
    })
  }

  animateVideo() {
    const start = this.el.getBoundingClientRect().top
    const end = this.el.getBoundingClientRect().top + this.el.offsetHeight
    const center = window.innerHeight / 2

    if (start <= center && end > center) {
      this.playVideo()
    } else {
      this.pauseVideo()
    }
  }

  playVideo() {
    this.el.classList.add('--active')
    this.player.play()
  }
  pauseVideo() {
    this.el.classList.remove('--active')
    this.player.pause()
  }
}
